import { getFile } from '@/services/privacy';

export default {
  agreePrivacyPolicy: ({ commit }) => commit('agreePrivacyPolicy'),

  getConfig: async ({ commit }) => {
    try {
      const { data, status } = await getFile();

      if (status === 200) {
        commit('setConfig', data);

        if (data.visible) {
          commit('setInit');
        }
      }

    } catch (err) {
      console.error(err);
    }
  }
};
